// extracted by mini-css-extract-plugin
export default {"Banner":"Banner_Banner__Xufyr","Whale":"Banner_Whale__dbuNA"};